import {Injectable, signal} from '@angular/core';
import {NonNullableFormBuilder} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {TmtErpPanelFilterForm, TmtErpPanelFilterModel} from '../models/tmt-erp-panel-filter-model';

@Injectable({
  providedIn: 'root'
})
export class TmtErpPanelFilterService {
  public readonly toggleModal = signal(false);

  public readonly filtersValue = signal<TmtErpPanelFilterModel>(this.buildDefaultFilters());

  private readonly filters$ = new BehaviorSubject<TmtErpPanelFilterModel>(this.filtersValue());

  public get form(): TmtErpPanelFilterForm {
    return this.formBuilder.group({
      SalesOrderId: [null as number | null],
      TripReference: [null as string | null],
      ErpOrderNumber: [null as string | null],
      ClientName: [null as string | null],
      CreatedDateFrom: [null as Date | null],
      CreatedDateTo: [null as Date | null],
      ErpSentDateFrom: [null as Date | null],
      ErpSentDateTo: [null as Date | null],
      ErpResponseDateFrom: [null as Date | null],
      ErpResponseDateTo: [null as Date | null],
      IsFailed: [null as boolean | null],
    });
  }

  constructor(private readonly formBuilder: NonNullableFormBuilder) {}

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: TmtErpPanelFilterModel) {
    this.filters$.next(value);
    this.filtersValue.set(value);
  }

  private buildDefaultFilters(): TmtErpPanelFilterModel {
    return {
      SalesOrderId: null,
      TripReference: null,
      ErpOrderNumber: null,
      ClientName: null,
      CreatedDateFrom: null,
      CreatedDateTo: null,
      ErpSentDateFrom: null,
      ErpSentDateTo: null,
      ErpResponseDateFrom: null,
      ErpResponseDateTo: null,
      IsFailed: null,
      ReloadGrid: false,
    };
  }
}
